"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Kits = void 0;

var loading_markup = void 0;
var noun_user = void 0;
var url_to_array = void 0;

loading_markup = '<div class="loading clearfix"><div class="dot dot1"></div><div class="dot dot2"></div><div class="dot dot3"></div><div class="dot dot4"></div></div>';

noun_user = require("../helpers/noun_user").default;

url_to_array = require("../helpers/url_to_array").default;

Kits = function () {
    function Kits() {
        var cardListeners = void 0;
        var closeCustomName = void 0;
        var closeKit = void 0;
        var hideAndRemove = void 0;
        var toggleLocked = void 0;
        var togglePublic = void 0;
        (0, _jquery2.default)("body").on("click", "#kit-container", function (e) {
            return e.stopPropagation();
        });
        (0, _jquery2.default)("body").on("click", ".new-custom-name", function (e) {
            return e.stopPropagation();
        });
        if (typeof String.prototype.trim === "undefined") {
            String.prototype.trim = function () {
                return String(this).replace(/^\s+|\s+$/g, "");
            };
        }
        _jquery2.default.fn.serializeObject = function () {
            var a = void 0;
            var o = void 0;
            o = {};
            a = this.serializeArray();
            _jquery2.default.each(a, function () {
                if (o[this.name] !== undefined) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || "");
                } else {
                    o[this.name] = this.value || "";
                }
            });
            return o;
        };
        (0, _jquery2.default)("body").on("click", "a.kit,.download-flow button.kit", function (e) {
            var $this = void 0;
            var container = void 0;
            var kitContainer = void 0;
            e.preventDefault();
            if (noun_user.is_anonymous === false) {
                //closeKit();
                e.stopPropagation();
                (0, _jquery2.default)("html").one("click", function (e) {
                    return closeKit();
                });
                $this = (0, _jquery2.default)(this);
                if (!$this.hasClass("ajaxing")) {
                    $this.addClass("ajaxing");
                    $this.removeClass("ui_kit").addClass("ui_kit-open");
                    container = (0, _jquery2.default)(".kit-wrapper");
                    container.addClass("kit-open");
                    (0, _jquery2.default)("body").addClass("kit-open");
                    kitContainer = container.find(".kit-container");
                    kitContainer.addClass("visible");
                    kitContainer.append(loading_markup);
                    _jquery2.default.ajax({
                        url: "/kit/retrieve/",
                        method: "GET",
                        data: {
                            username: noun_user.username,
                            icon_id: $this.attr("data-icon-id")
                        },
                        success: function success(data, status, xhr) {
                            var messageBox = void 0;
                            var searchInput = void 0;
                            var showNewKitForm = void 0;
                            $this.removeClass("ajaxing");
                            if (kitContainer.find("form").length <= 0) {
                                kitContainer.append(data);
                                if ((0, _jquery2.default)("#term-detail").length > 0) {
                                    (0, _jquery2.default)(".kits_list").append((0, _jquery2.default)(".popup-kits-list"));
                                }
                                kitContainer.find(".loading").remove();
                                kitContainer.find('input[type="search"]').focus();
                                (0, _jquery2.default)(".kit-name a").click(function (e) {
                                    var $me = void 0;
                                    var parent = void 0;
                                    e.preventDefault();
                                    $me = (0, _jquery2.default)(this);
                                    (0, _jquery2.default)(this).addClass("match");
                                    (0, _jquery2.default)(".popup-kits-list").css({
                                        border: "none"
                                    });
                                    (0, _jquery2.default)(this).toggleClass("added ui_kit");
                                    parent = $me.parent("li");
                                    parent.addClass("keeper");
                                    (0, _jquery2.default)(".kit-name:not(.keeper)").remove();
                                    kitContainer.find("input").remove();
                                    kitContainer.find(".get-more-kits").remove();
                                    kitContainer.find(".make-a-new-kit").remove();
                                    kitContainer.find(".ui_search").remove();
                                    (0, _jquery2.default)("a.kit").addClass("added");
                                    $me.addClass("inactive");
                                    return _jquery2.default.ajax({
                                        url: e.target.href,
                                        method: "POST",
                                        success: function success(data, status, xhr) {

                                            return setTimeout(function () {
                                                closeKit();
                                                return console.log("close now");
                                            }, 500);
                                        },
                                        error: function error() {
                                            $me.removeClass("inactive");
                                            return console.log("Something went wrong try again");
                                        }
                                    });
                                });
                                searchInput = kitContainer.find('input[type="search"]');
                                messageBox = kitContainer.find("span.message");
                                (0, _jquery2.default)(".make-a-new-kit").click(function (e) {
                                    e.preventDefault();

                                    return showNewKitForm(e, searchInput.val());
                                });
                                (0, _jquery2.default)("body").on("keyup", kitContainer, function (e) {
                                    var match = void 0;
                                    var totalKits = void 0;
                                    var value = void 0;
                                    value = (0, _jquery2.default)(searchInput).val().toLowerCase();
                                    if (e.keyCode === 13) {

                                        e.preventDefault();
                                        if ((0, _jquery2.default)(".match").length === 1) {
                                            match = (0, _jquery2.default)(".match").children("a")[0];
                                            if ((0, _jquery2.default)(match).hasClass("added")) {
                                                return closeKit();
                                            } else {
                                                return (0, _jquery2.default)(match).click();
                                            }
                                        } else if ((0, _jquery2.default)("input[name='can_create_kits']").val() === "True") {
                                            return showNewKitForm(e, searchInput.val());
                                        }
                                    } else {
                                        totalKits = kitContainer.find(".kit-name").length;
                                        kitContainer.find(".kit-name").each(function () {
                                            var name = void 0;
                                            var regexp = void 0;
                                            $this = (0, _jquery2.default)(this);
                                            name = $this.text().toLowerCase();
                                            regexp = new RegExp(value);

                                            if (name.match(regexp)) {

                                                $this.removeClass("not-a-match");
                                                if (name.trim() === value.trim() || (0, _jquery2.default)(".not-a-match").length === totalKits - 1) {
                                                    return $this.addClass("match");
                                                } else {
                                                    return $this.removeClass("match");
                                                }
                                            } else {
                                                $this.addClass("not-a-match");
                                                return $this.removeClass("match");
                                            }
                                        });
                                        if (value.length === 0) {
                                            return $this.removeClass("match");
                                        }
                                    }
                                });
                                kitContainer.find("form").submit(function (e) {
                                    return false;
                                });
                                return showNewKitForm = function showNewKitForm(e, newKitName) {
                                    e.preventDefault();
                                    kitContainer.find("input[name=new-kit-name]").val(newKitName);
                                    kitContainer.find(".kits_list").removeClass("visible");
                                    kitContainer.find(".new_kit").addClass("visible");
                                    kitContainer.find("textarea[name=new-kit-description]").focus();
                                    return kitContainer.find("form").submit(function (e) {
                                        var description = void 0;
                                        var icon_id = void 0;
                                        var is_public = void 0;
                                        var kitName = void 0;
                                        var messageKit = void 0;
                                        var owner_id = void 0;
                                        var ref = void 0;
                                        e.preventDefault();
                                        kitName = kitContainer.find("input[name=new-kit-name]").val();
                                        description = kitContainer.find("textarea[name=new-kit-description]").val();
                                        owner_id = kitContainer.find("select[name=new-kit-owner]").val();
                                        is_public = (ref = (0, _jquery2.default)("input[name=new-kit-is_public]").prop("checked")) != null ? ref : {
                                            on: "off"
                                        };

                                        icon_id = kitContainer.find("input[name=icon-id]").val();
                                        return _jquery2.default.ajax({
                                            url: "/kit/new/",
                                            method: "POST",
                                            dataType: "json",
                                            data: {
                                                name: kitName,
                                                description: description,
                                                owner_id: owner_id,
                                                icon_id: icon_id,
                                                is_public: is_public,
                                                popup: true
                                            },
                                            success: function success(data, status, xhr) {
                                                var grabAKit = void 0;
                                                if (data.errors) {

                                                    return messageKit(data.errors.name[0]);
                                                } else {

                                                    grabAKit = (0, _jquery2.default)(".kit-name:first-child");
                                                    grabAKit.addClass("keeper").removeClass("not-a-match");
                                                    grabAKit.find("a").text((0, _jquery2.default)("input[name=new-kit-name]").val()).addClass("added ui_kit");
                                                    grabAKit.appendTo(kitContainer);
                                                    kitContainer.find("form").hide();
                                                    (0, _jquery2.default)("a.kit").addClass("added");
                                                    return closeKit();
                                                }
                                            },
                                            error: function error(xhr, textStatus, errorThrown) {

                                                return messageKit(xhr.responseJSON.description);
                                            }
                                        }, messageKit = function messageKit(message) {
                                            messageBox.slideDown(500);
                                            messageBox.text(message);
                                            messageBox.addClass("ui_important");
                                            return setTimeout(function () {
                                                return messageBox.slideUp(500);
                                            }, 2000);
                                        });
                                    });
                                };
                            }
                        },
                        error: function error() {
                            kitContainer.html("<p>Couldn't get your kits. Try again.</p>");
                            return setTimeout(function () {
                                return closeKit();
                            }, 2000);
                        }
                    });
                }
                return (0, _jquery2.default)(".kit-container").click(function (event) {
                    return event.stopPropagation();
                });
            } else {
                return location.href = "//" + url_to_array[2] + "/accounts/login/?next=" + location.pathname;
            }
        });
        closeKit = function closeKit(e) {
            var visibleKit = void 0;
            visibleKit = (0, _jquery2.default)(".kit-container.visible");
            if (visibleKit.length > 0) {
                visibleKit.removeClass("visible");
                (0, _jquery2.default)("body").removeClass("kit-open");
                (0, _jquery2.default)(".container.kit-open").removeClass("kit-open");
                (0, _jquery2.default)("a.kit").addClass("ui_kit").removeClass("ui_kit-open", "ajaxing");
                return setTimeout(function () {
                    visibleKit.find("form").remove();
                    return visibleKit.find("li").remove();
                }, 500);
            }
        };
        (0, _jquery2.default)(".create-new-kit").on("click", function (e) {
            e.preventDefault();
            (0, _jquery2.default)(this).hide();
            (0, _jquery2.default)("form#create-new-kit span.message").hide();
            return (0, _jquery2.default)("form#create-new-kit").addClass("visible");
        });
        cardListeners = function cardListeners() {
            (0, _jquery2.default)(".card a.card-information").on("click", function (e) {
                var parent = void 0;
                e.preventDefault();
                parent = (0, _jquery2.default)(this).parents(".card");
                parent.find("form.edit-kit-form").hide();
                parent.find(".delete-confirmation").hide();
                parent.find(".description").show();
                return parent.toggleClass("flip");
            });
            (0, _jquery2.default)(".card a.edit-kit-info").on("click", function (e) {
                var deny = void 0;
                var parent = void 0;
                e.preventDefault();
                parent = (0, _jquery2.default)(this).parents(".card");
                parent.toggleClass("flip");
                parent.find(".description").hide();
                parent.find(".delete-confirmation").hide();
                parent.find("form").show();
                deny = parent.find(".deny-edit-kit");
                return deny.click(function (e) {
                    e.preventDefault();
                    (0, _jquery2.default)(this).removeClass("loading");
                    parent.removeClass("flip");
                    return setTimeout(function () {
                        parent.find("form.edit-kit-form").hide();
                        return parent.find(".description").show();
                    }, 500);
                });
            });
            (0, _jquery2.default)("footer a.delete-kit").on("click", function (e) {
                var confirm = void 0;
                var deny = void 0;
                var parent = void 0;
                e.preventDefault();
                parent = (0, _jquery2.default)(this).parents(".card");
                parent.addClass("flip");
                parent.find(".delete-confirmation").show();
                parent.find(".description").hide();
                confirm = parent.find(".confirm-delete-kit");
                deny = parent.find(".deny-delete-kit");
                confirm.click(function () {
                    e.preventDefault;
                    return _jquery2.default.ajax({
                        url: e.target.href,
                        method: "POST",
                        success: function success(data, status, xhr) {

                            return hideAndRemove(parent);
                        },
                        error: function error(xhr, textStatus, errorThrown) {

                            return (0, _jquery2.default)(this).removeClass("loading");
                        }
                    });
                });
                return deny.click(function (e) {
                    (0, _jquery2.default)(this).removeClass("loading");
                    parent.removeClass("flip");
                    parent.find(".delete-confirmation").hide();
                    return parent.find(".description").show();
                });
            });
            (0, _jquery2.default)("footer a.publicize-kit").on("click", function (e) {
                var el = void 0;
                e.preventDefault();
                el = this;
                (0, _jquery2.default)(this).addClass("loading");
                return _jquery2.default.ajax({
                    url: e.target.href,
                    method: "POST",
                    success: function success(data, status, xhr) {

                        return togglePublic(el);
                    },
                    error: function error(xhr, textStatus, errorThrown) {

                        return (0, _jquery2.default)(el).removeClass("loading");
                    }
                });
            });
            return (0, _jquery2.default)("footer a.lock-kit").on("click", function (e) {
                var el = void 0;
                e.preventDefault();
                el = this;
                (0, _jquery2.default)(this).addClass("loading");
                return _jquery2.default.ajax({
                    url: e.target.href,
                    method: "POST",
                    success: function success(data, status, xhr) {

                        return toggleLocked(el);
                    },
                    error: function error(xhr, textStatus, errorThrown) {

                        return (0, _jquery2.default)(el).removeClass("loading");
                    }
                });
            });
        };
        cardListeners();
        (0, _jquery2.default)("body").on("click", ".term .ui_pencil", function (e) {
            var $this = void 0;
            var parent = void 0;
            e.preventDefault();
            $this = (0, _jquery2.default)(this);
            e.stopPropagation();
            (0, _jquery2.default)("html").one("click", function (e) {
                return closeCustomName($this);
            });
            parent = $this.parents("footer");
            parent.find(".term").hide();
            parent.find("form").show();
            return parent.find("input").focus();
        });
        closeCustomName = function closeCustomName(obj) {
            var $this = void 0;
            var parent = void 0;
            $this = obj;
            parent = $this.parents("footer");
            parent.find(".term").show();
            return parent.find("form").hide();
        };
        (0, _jquery2.default)("body").on("submit", "form.new-custom-name", function (e) {
            var $form = void 0;
            var $saveButton = void 0;
            var data = void 0;
            e.preventDefault();

            data = (0, _jquery2.default)(this).serializeObject();
            $form = (0, _jquery2.default)(this);
            $saveButton = $form.find("button");
            $saveButton.removeClass("ui_save");
            $saveButton.addClass("loading");
            return _jquery2.default.ajax({
                url: e.target.action,
                method: "POST",
                data: data,
                success: function success(data, status, xhr) {

                    $saveButton.removeClass("loading");
                    $saveButton.addClass("ui_save");
                    $form.hide();
                    $form.parent().find(".term").show();
                    $form.parent().find(".term small.term-name").removeClass("hidden");
                    return $form.parent().find(".kiticon-name").text(data);
                },
                error: function error(xhr, textStatus, errorThrown) {
                    return console.log("error!", xhr);
                }
            });
        });
        (0, _jquery2.default)("form#create-new-kit").on("submit", function (e) {
            var $createButton = void 0;
            var $form = void 0;
            var data = void 0;
            var messageBox = void 0;
            var messageKit = void 0;
            e.preventDefault();
            data = (0, _jquery2.default)(this).serializeObject();
            $form = (0, _jquery2.default)(this);
            $createButton = $form.find("button");
            $createButton.addClass("loading");
            messageBox = $form.parent().find("span.message");

            messageKit = function messageKit(message) {
                messageBox.slideDown(500);
                messageBox.text(message);
                messageBox.addClass("ui_important");
                return setTimeout(function () {
                    return messageBox.slideUp(500);
                }, 2000);
            };
            return _jquery2.default.ajax({
                url: e.target.action,
                method: "POST",
                data: data,
                success: function success(data, status, xhr) {
                    if (data.errors) {

                        return messageKit(data.errors.name[0]);
                    } else {
                        $createButton.removeClass("loading");
                        $form.removeClass("visible");
                        $form[0].reset();
                        (0, _jquery2.default)(data).insertBefore((0, _jquery2.default)("#new-kit-card"));
                        (0, _jquery2.default)(".create-new-kit").show();
                        return cardListeners();
                    }
                }
            });
        });
        (0, _jquery2.default)("body").on("click", "a.kit.delete-icon", function (e) {
            var that = void 0;
            e.preventDefault();
            (0, _jquery2.default)(this).addClass("loading");
            that = this;
            return _jquery2.default.ajax({
                url: e.target.href,
                method: "POST",
                success: function success(data, status, xhr) {
                    (0, _jquery2.default)(that).removeClass("loading");
                    (0, _jquery2.default)(that).parent().addClass("deleting");
                    (0, _jquery2.default)(that).parent().hide(500);
                    return setTimeout(function () {
                        return (0, _jquery2.default)(that).parent().remove();
                    }, 500);
                },
                error: function error(xhr, textStatus, errorThrown) {
                    return console.log("error!", xhr);
                }
            });
        });
        (0, _jquery2.default)("form.edit-kit-form").on("submit", function (e) {
            var $form = void 0;
            var $saveButton = void 0;
            var data = void 0;
            var parent = void 0;
            e.preventDefault();
            data = (0, _jquery2.default)(this).serializeObject();
            $form = (0, _jquery2.default)(this);
            parent = (0, _jquery2.default)(this).parents(".card");
            $saveButton = $form.find("button.confirm-edit-kit");
            $saveButton.addClass("loading");
            return _jquery2.default.ajax({
                url: e.target.action,
                method: "POST",
                data: data,
                success: function success(data, status, xhr) {
                    var shortName = void 0;

                    $saveButton.removeClass("loading");
                    parent.removeClass("flip");
                    parent.find(".description").text(data.description).show();
                    if (data.name.length > 20) {
                        shortName = data.name.substring(0, 20) + "\u2026";
                    } else {
                        shortName = data.name;
                    }
                    parent.find(".front span.name").text(shortName).attr("title", data.name);
                    return $form.hide();
                },
                error: function error(xhr, textStatus, errorThrown) {
                    return console.log("error!", xhr);
                }
            });
        });
        hideAndRemove = function hideAndRemove(el) {
            return (0, _jquery2.default)(el).hide(500, function () {
                return (0, _jquery2.default)(el).remove();
            });
        };
        toggleLocked = function toggleLocked(el) {
            (0, _jquery2.default)(el).removeClass("loading");
            (0, _jquery2.default)(el).toggleClass("ui_lock");
            (0, _jquery2.default)(el).toggleClass("ui_unlock");
            if ((0, _jquery2.default)(el).hasClass("ui_lock")) {
                return (0, _jquery2.default)(el).attr("title", "Locked");
            } else {
                return (0, _jquery2.default)(el).attr("title", "Unlocked");
            }
        };
        togglePublic = function togglePublic(el) {
            (0, _jquery2.default)(el).removeClass("loading");
            (0, _jquery2.default)(el).toggleClass("ui_eye");
            (0, _jquery2.default)(el).toggleClass("ui_eye-off");
            if ((0, _jquery2.default)(el).hasClass("ui_eye")) {
                (0, _jquery2.default)(el).attr("title", "Public");
                return (0, _jquery2.default)(el).siblings(".share").removeClass("hide");
            } else {
                (0, _jquery2.default)(el).attr("title", "Private");
                return (0, _jquery2.default)(el).siblings(".share").addClass("hide");
            }
        };
    }

    return Kits;
}();

exports.default = new Kits();